import DashboardIcon from "@assets/componentIcons/DashboardIcon";
import {
  ResourceCenterIcon,
  StoreFrontIcon,
} from "@assets/componentIcons/ResourceCenterIcon";
import UserAdminIcon from "@assets/componentIcons/UserAdminIcon";
import SettingsIcon from "@assets/componentIcons/SettingsIcon";
import { constRoute } from "@utils/route";

export const navigationItems = [
  {
    name: "Monitoring",
    icon: DashboardIcon,
    navigation: constRoute.masteradminDashboard,
  },
  {
    name: "Manage Users",
    icon: UserAdminIcon,
    navigation: constRoute.masteradminUsers,
  },
  {
    name: "Prompts Panel",
    icon: ResourceCenterIcon,
    navigation: constRoute.masteradminPromptPanel,
  },
  {
    name: "Resource Center",
    icon: StoreFrontIcon,
    navigation: constRoute.masteradminResource,
  },
  {
    name: "App Settings",
    icon: SettingsIcon,
    navigation: constRoute.masteradminAppSettings,
  },
];
